var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-listado-desktop"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.listadoAdjudicacionesDirectas,"items-per-page":20},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('opciones',{attrs:{"adjudicacionDirecta":item}})]}},{key:"item.fecha",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(new Date(item.fecha).toLocaleDateString())+"\n    ")]}},{key:"item.importe",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm._f("currency")(item.importe))+"\n    ")]}},{key:"item.iva",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm._f("currency")(item.iva))+"\n    ")]}},{key:"item.total",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm._f("currency")(item.total))+"\n    ")]}},{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_c('fecha-humano',{attrs:{"fecha":new Date(item.createdAt)}})]}},{key:"item.meta",fn:function(ref){
var item = ref.item;
return [_c('cortar-texto',{attrs:{"texto":item.meta}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }